"use client";

import { Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon, PhoneIcon } from "@heroicons/react/24/solid";
import Link from "next/link";
import { Fragment } from "react";

const solutions = [
  {
    name: "Property Owner",
    description: "Appraisal Form",
    href: "/order/property-owner",
    icon: IconOne,
  },
 
  {
    name: "Probate Estate", // New Option Added
    description: "Appraisal Form",
    href: "/order/probate-estate", // Adjust the route as necessary
    icon: IconSix, // Assign an icon
  },
 {
    name: "Home Buyers",
    description: "Appraisal Form",
    href: "/order/buyers",
    icon: IconFirst,
  },
  {
    name: "Broker/ Lender",
    description: "Appraisal Form",
    href: "/order/broker-lender",
    icon: IconTwo,
  },
  {
    name: "Lawyer/ Accountant",
    description: "Appraisal Form",
    href: "/order/lawyer-accountant-other",
    icon: IconThree,
  },
  {
    name: "Proposal/ Insolvency",
    description: "Appraisal Form",
    href: "/order/proposal-insolvency",
    icon: IconFour,
  },
  {
    name: "Power of Sale",
    description: "Appraisal Form",
    href: "/order/power-of-sale",
    icon: IconFive,
  },


];

export default function PopOver({ onClose }) {
  return (
<div className="relative z-[100]  w-full max-w-full font-cinzel">
<Popover className="relative z-[100]">
        {({ open }) => (
          <>
            <Popover.Button
              className={`
                ${open ? "" : "text-opacity-90"} 
                outline-none w-full text-center align-middle justify-center border-none  font-semibold    hover:font-bold hover:text-black"  group inline-flex items-center rounded-t-md bg-blue-700 px-0  text-xl sm:text-2xl sm:px-2 py-10  text-white hover:text-opacity-100 `}
            >
              <span className="transition duration-500   ">
                Order An Appraisal
              </span>
              <ChevronDownIcon
                className={`${open ? "" : "text-opacity-70"}
                  ml-2 h-7 w-7 text-white hover:bg-blue-500 duration-300  transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-110 animate-bounce  group-hover:text-opacity-80`}
                aria-hidden="true"
              />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel
                focus={true}
                className=" outline-none   border-none z-[100] transform  lg:px-0 "
              >
                <div className="overflow-hidden rounded-lg shadow-lg ">
                <div className="grid md:flex pt-5 pb-5 md:p-10 justify-evenly lg:flex lg:flex-row gap-10 bg-white dark:bg-slate-800 lg:grid-cols-3">                   {solutions.map((item) => (
                      <Link
                        onClick={onClose}
                        key={item.name}
                        href={item.href}
                        className="-m-1 grid border-8 outline-none  border-none  p-5 sm:p-2 w-72 items-start text-center justify-center sm:justify-center rounded-lg transition duration-150 ease-in-out hover:dark:text-black hover:text-black hover:bg-yellow-100 dark:hover:bg-gray-50"
                      >
                        <div className="grid h-15 w-15 shrink-0 items-center text-center justify-center text-yellow-600 ">
                          <item.icon aria-hidden="true" />
                        </div>
                        <div className="">
                          <p className="text-lg font-medium text-center sm:text-center">
                            {item.name}
                          </p>
                          <p className="text-sm text-gray-500  sm:text-center text-center  ">
                            {item.description}
                          </p>
                        </div>
                      </Link>
                    ))}
                  </div>
                  <div className="bg-gray-50 dark:bg-slate-500 p-3 flex justify-evenly center ">
                    <span className=" text-sm items-center ">
                      <a href="tel:+1-416-450-2336">
                        <span className="text-sm font-medium flex  place-items-center ">
                          <PhoneIcon className=" h-3 px-2" /> (416)-450-2336
                        </span>
                      </a>
                    </span>
                    <span className=" text-sm text-yellow-600 dark:text-white">
                      Alpha Appraisals Inc.
                    </span>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
}

function IconOne() {
  return (
    <svg fill="none" viewBox="0 0 15 15" height="1em" width="1em">
      <path
        fill="currentColor"
        d="M4.5 8.5H4a.5.5 0 00.5.5v-.5zm4 0V9a.5.5 0 00.5-.5h-.5zm0-2.5H9a.5.5 0 00-.146-.354L8.5 6zm-2-2l.354-.354a.5.5 0 00-.708 0L6.5 4zm-2 2l-.354-.354A.5.5 0 004 6h.5zm10.354 8.146l-4-4-.708.708 4 4 .708-.708zM6.5 12A5.5 5.5 0 011 6.5H0A6.5 6.5 0 006.5 13v-1zM12 6.5A5.5 5.5 0 016.5 12v1A6.5 6.5 0 0013 6.5h-1zM6.5 1A5.5 5.5 0 0112 6.5h1A6.5 6.5 0 006.5 0v1zm0-1A6.5 6.5 0 000 6.5h1A5.5 5.5 0 016.5 1V0zm-2 9h4V8h-4v1zM9 8.5V6H8v2.5h1zm-.146-2.854l-2-2-.708.708 2 2 .708-.708zm-2.708-2l-2 2 .708.708 2-2-.708-.708zM4 6v2.5h1V6H4z"
      />
    </svg>
  );
}

function IconFirst() {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
    >
      <path stroke="none" d="M0 0h24v24H0z" />
      <path d="M9 21v-6a2 2 0 012-2h2a2 2 0 012 2" />
      <path d="M19 13.488V12h2l-9-9-9 9h2v7a2 2 0 002 2h4.525M15 19l2 2 4-4" />
    </svg>
  );
}

function IconTwo() {
  return (
    <svg fill="currentColor" viewBox="0 0 16 16" height="1em" width="1em">
      <path d="M8 0l6.61 3h.89a.5.5 0 01.5.5v2a.5.5 0 01-.5.5H15v7a.5.5 0 01.485.38l.5 2a.498.498 0 01-.485.62H.5a.498.498 0 01-.485-.62l.5-2A.501.501 0 011 13V6H.5a.5.5 0 01-.5-.5v-2A.5.5 0 01.5 3h.89L8 0zM3.777 3h8.447L8 1 3.777 3zM2 6v7h1V6H2zm2 0v7h2.5V6H4zm3.5 0v7h1V6h-1zm2 0v7H12V6H9.5zM13 6v7h1V6h-1zm2-1V4H1v1h14zm-.39 9H1.39l-.25 1h13.72l-.25-1z" />
    </svg>
  );
}

function IconThree() {
  return (
    <svg viewBox="0 0 640 512" fill="currentColor" height="1em" width="1em">
      <path d="M384 32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h160V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h128c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zM125.8 177.3L51.1 320h153.8l-74.7-142.7c-.4-.8-1.3-1.3-2.2-1.3s-1.7.5-2.2 1.3zM128 128c18.8 0 36 10.4 44.7 27l77.8 148.5c3.1 5.8 6.1 14 5.5 23.8-.7 12.1-4.8 35.2-24.8 55.1-20.3 20.2-53 33.6-103.2 33.6s-82.9-13.4-103.2-33.5c-20-20-24.2-43-24.8-55.1-.6-9.8 2.5-18 5.5-23.8L83.3 155c8.7-16.6 25.9-27 44.7-27zm384 48c-.9 0-1.7.5-2.2 1.3L435.1 320h153.8l-74.7-142.7c-.4-.8-1.3-1.3-2.2-1.3zm-44.7-21c8.7-16.6 25.9-27 44.7-27s36 10.4 44.7 27l77.8 148.5c3.1 5.8 6.1 14 5.5 23.8-.7 12.1-4.8 35.2-24.8 55.1-20.3 20.2-53 33.6-103.2 33.6s-82.9-13.4-103.2-33.5c-20-20-24.2-43-24.8-55.1-.6-9.8 2.5-18 5.5-23.8L467.3 155z" />
    </svg>
  );
}



function IconFour() {
  return (
    <svg fill="none" viewBox="0 0 24 24" height="1em" width="1em">
    <path
      fill="currentColor"
      d="M8 11a1 1 0 100 2h7.96a1 1 0 100-2H8zM8.04 15.066a1 1 0 100 2H16a1 1 0 100-2H8.04z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2H5zm2 2H5v14h14V5h-2v1a3 3 0 01-3 3h-4a3 3 0 01-3-3V5zm2 0v1a1 1 0 001 1h4a1 1 0 001-1V5H9z"
      clipRule="evenodd"
    />
  </svg>
  );
}


function IconFive() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"  height="1em" width="1em">
    <path stroke-linecap="round" stroke-linejoin="round" d="M16.712 4.33a9.027 9.027 0 0 1 1.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 0 0-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 0 1 0 9.424m-4.138-5.976a3.736 3.736 0 0 0-.88-1.388 3.737 3.737 0 0 0-1.388-.88m2.268 2.268a3.765 3.765 0 0 1 0 2.528m-2.268-4.796a3.765 3.765 0 0 0-2.528 0m4.796 4.796c-.181.506-.475.982-.88 1.388a3.736 3.736 0 0 1-1.388.88m2.268-2.268 4.138 3.448m0 0a9.027 9.027 0 0 1-1.306 1.652c-.51.51-1.064.944-1.652 1.306m0 0-3.448-4.138m3.448 4.138a9.014 9.014 0 0 1-9.424 0m5.976-4.138a3.765 3.765 0 0 1-2.528 0m0 0a3.736 3.736 0 0 1-1.388-.88 3.737 3.737 0 0 1-.88-1.388m2.268 2.268L7.288 19.67m0 0a9.024 9.024 0 0 1-1.652-1.306 9.027 9.027 0 0 1-1.306-1.652m0 0 4.138-3.448M4.33 16.712a9.014 9.014 0 0 1 0-9.424m4.138 5.976a3.765 3.765 0 0 1 0-2.528m0 0c.181-.506.475-.982.88-1.388a3.736 3.736 0 0 1 1.388-.88m-2.268 2.268L4.33 7.288m6.406 1.18L7.288 4.33m0 0a9.024 9.024 0 0 0-1.652 1.306A9.025 9.025 0 0 0 4.33 7.288" />
  </svg>
  
  );
}
function IconSix() {
  return (
    <svg fill="currentColor" viewBox="0 0 24 24" height="1em" width="1em">
      <path d="M12 2L1 9h22L12 2zm10 10H2v10h20V12zm-2 2v6H4v-6h16z" />
    </svg>
  );
}
